import type {
  ConfigurationResourceReadV2Api,
  ConfigurationResourceWriteV2Api,
} from '@ingenico/api-sdk-device-management-private-v2';
import { isEmpty } from 'lodash-es';

/**
 * The PUT endpoint replaces the whole resource, so every field the modal does not own is carried
 * over from the GET. Omitting deploymentPriority is what deletes it.
 * The GET definition also holds read-only fields (names, module names) that the PUT rejects, so
 * only the writable attributes are kept.
 */
export function mapUpdateDeploymentPriorityRequest(
  configuration: ConfigurationResourceReadV2Api,
  deploymentPriority?: number,
): ConfigurationResourceWriteV2Api {
  const { compositions, configuration: content } = configuration.definition;

  return {
    name: configuration.name,
    ...(configuration.description ? { description: configuration.description } : {}),
    ...(deploymentPriority === undefined ? {} : { deploymentPriority }),
    definition: {
      compositions: (compositions ?? []).map(({ configurationId }) => ({ configurationId })),
      ...(content
        ? {
            configuration: {
              applicationVersions: (content.applicationVersions ?? []).map(({ id, order, type }) => ({
                id,
                order,
                type,
              })),
              systemPackageVersions: (content.systemPackageVersions ?? []).map(({ id, order, type }) => ({
                id,
                order,
                type,
              })),
              ...(content.osVersion ? { osVersion: { id: content.osVersion.id } } : {}),
              ...(isEmpty(content.remoteKeyInjection) ? {} : { remoteKeyInjection: content.remoteKeyInjection }),
            },
          }
        : {}),
    },
  } as ConfigurationResourceWriteV2Api;
}
